import React from 'react';
import { useIntl } from 'react-intl';
import { AsideMenuItem } from './AsideMenuItem';
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub';
import { shallowEqual, useSelector } from 'react-redux';
import { UserModel } from '../../../../app/modules/auth/models/UserModel';
import { RootState } from '../../../../setup/index';
import { userHasRole } from '../../../helpers';

export function AsideMenuMain() {
  const user: UserModel = useSelector<RootState>(
    ({ auth }) => auth.user,
    shallowEqual
  ) as UserModel;
  const { roles: userRoles } = user;
  const intl = useIntl();

  return (
    <>
      {userHasRole(
        ['ADMIN', 'TESO', 'SERVCLIENTE', 'COMPRAS', 'SUPERVISOR'],
        userRoles
      ) && (
        <AsideMenuItem
          to="/dashboard"
          icon="/media/icons/duotune/graphs/gra008.svg"
          title={'Inicio'}
          fontIcon="bi-app-indicator"
        />
      )}

      {userHasRole(['ADMIN', 'TESO'], userRoles) && (
        <AsideMenuItemWithSub
          icon="/media/icons/duotune/finance/fin001.svg"
          fontIcon="bi-layers"
          to="/tesoreria/"
          title="Inicio y Cierre de Día"
          hasBullet={false}
        >
          <AsideMenuItem
            to="/tesoreria/entrega_caja/"
            icon="/media/icons/duotune/finance/fin010.svg"
            title="Iniciar día y caja"
            fontIcon="bi-app-indicator"
          />
          <AsideMenuItem
            to="/tesoreria/corte_caja/"
            title="Corte de caja y día"
            icon="/media/icons/duotune/finance/fin010.svg"
          />
        </AsideMenuItemWithSub>
      )}

      {userHasRole(['ADMIN', 'COMPRAS'], userRoles) && (
        <>
          <AsideMenuItemWithSub
            icon="/media/icons/duotune/ecommerce/ecm001.svg"
            fontIcon="bi-layers"
            to="/compras/"
            title="Compras a Proveedores"
            hasBullet={false}
          >
            <AsideMenuItem
              to="/compras/proveedores"
              title="Proveedores"
              icon="/media/icons/duotune/communication/com006.svg"
            />
            <AsideMenuItem
              to="/compras/donativos/"
              title="Compras y donativos"
              icon="/media/icons/duotune/finance/fin011.svg"
            />
          </AsideMenuItemWithSub>
        </>
      )}
      {userHasRole(['ADMIN', 'COMPRAS'], userRoles) && (
        <>
          <AsideMenuItemWithSub
            icon="/media/icons/duotune/ecommerce/ecm005.svg"
            fontIcon="bi-layers"
            to="/ventas/"
            title="Ventas a Puntos de Venta"
            hasBullet={false}
          >
            <AsideMenuItem
              to="/ventas/puntos_venta/"
              title="Puntos de venta"
              icon="/media/icons/duotune/ecommerce/ecm004.svg"
            />
            <AsideMenuItem
              to="/ventas/ventas_puntos_venta/"
              title="Suministro a puntos de venta"
              icon="/media/icons/duotune/ecommerce/ecm006.svg"
            />
            <AsideMenuItem
              to="/ventas/conciliacion/"
              title="Conciliación de ventas"
              icon="/media/icons/duotune/finance/fin014.svg"
            />
          </AsideMenuItemWithSub>
        </>
      )}

      {userHasRole(['ADMIN', 'SERVCLIENTE'], userRoles) && (
        <>
          <AsideMenuItemWithSub
            icon="/media/icons/duotune/communication/com006.svg"
            fontIcon="bi-layers"
            to="/servicio_cliente/"
            title="Servicio al cliente"
            hasBullet={false}
          >
            <AsideMenuItem
              to="/servicio_cliente/enrolamiento/"
              icon="/media/icons/duotune/ecommerce/ecm010.svg"
              title="Enrolamiento"
              fontIcon="bi-app-indicator"
            />
            <AsideMenuItem
              to="/servicio_cliente/recuperar_saldo/"
              title="Recuperar saldo"
              icon="/media/icons/duotune/finance/fin012.svg"
            />
            <AsideMenuItem
              to="/servicio_cliente/consultar_saldo/"
              title="Consultar saldo"
              icon="/media/icons/duotune/finance/fin010.svg"
            />
            <AsideMenuItem
              to="/servicio_cliente/consultar_movimientos/"
              title="Consultar movimientos"
              icon="/media/icons/duotune/finance/fin010.svg"
            />
            <AsideMenuItem
              to="/servicio_cliente/historial_recargas/"
              title="Historial de Recargas"
              icon="/media/icons/duotune/finance/fin011.svg"
            />
          </AsideMenuItemWithSub>
        </>
      )}

      {userHasRole(['ADMIN'], userRoles) && (
        <>
          <AsideMenuItemWithSub
            icon="/media/icons/duotune/files/fil002.svg"
            fontIcon="bi-layers"
            to="/eventos/"
            title="Eventos"
            hasBullet={false}
          >
            <AsideMenuItem
              to="/eventos/listado_eventos"
              title="Listado de eventos"
              icon="/media/icons/duotune/files/fil001.svg"
            />
            {/* <AsideMenuItem
              to="/eventos/asignacion_puntos_venta"
              title="Asignación de puntos de venta"
              icon="/media/icons/duotune/ecommerce/ecm009.svg"
            /> */}
          </AsideMenuItemWithSub>
        </>
      )}

      {userHasRole(['ADMIN', 'TESO'], userRoles) && (
        <>
          <AsideMenuItemWithSub
            icon="/media/icons/duotune/files/fil003.svg"
            fontIcon="bi-layers"
            to="/reportes/"
            title="Reportes"
            hasBullet={false}
          >
            {/* <AsideMenuItem
              to="/reportes/cortesias"
              title="Cortesías"
              icon="/media/icons/duotune/files/fil003.svg"
            /> */}
            <AsideMenuItem
              to="/reportes/ventas"
              title="Reporte de Cajas"
              icon="/media/icons/duotune/files/fil003.svg"
            />
            <AsideMenuItem
              to="/reportes/conciliacion"
              title="Reporte de Conciliación"
              icon="/media/icons/duotune/files/fil003.svg"
            />
            <AsideMenuItem
              to="/reportes/retiros"
              title="Reporte de Retiros"
              icon="/media/icons/duotune/files/fil003.svg"
            />
            <AsideMenuItem
              to="/reportes/reporte-ventas"
              title="Reporte de Ventas"
              icon="/media/icons/duotune/files/fil003.svg"
            />
            <AsideMenuItem
              to="/reportes/ventas-cortesias"
              title="Reporte de Ventas con Cortesías"
              icon="/media/icons/duotune/files/fil003.svg"
            />
            <AsideMenuItem
              to="/reportes/remanente-tickets"
              title="Remanente de Tickets"
              icon="/media/icons/duotune/files/fil003.svg"
            />
            {/* <AsideMenuItem
              to="/reportes/reporte_compra_donativo"
              title="Reportes de Inventario"
              icon="/media/icons/duotune/files/fil003.svg"
            />
            <AsideMenuItem
              to="/reportes/reporte_compra_donativo"
              title="Reportes de Conciliación"
              icon="/media/icons/duotune/files/fil003.svg"
            /> */}
          </AsideMenuItemWithSub>
        </>
      )}

      {userHasRole(['ADMIN'], userRoles) && (
        <>
          <AsideMenuItemWithSub
            icon="/media/icons/duotune/ecommerce/ecm010.svg"
            fontIcon="bi-layers"
            to="/tickets/"
            title="Tickets"
            hasBullet={false}
          >
            <AsideMenuItem
              to="/tickets/generacion_tickets"
              title="Generación de Tickets"
              icon="/media/icons/duotune/general/gen005.svg"
            />
          </AsideMenuItemWithSub>
        </>
      )}

      {userHasRole(['ADMIN'], userRoles) && (
        <>
          <AsideMenuItemWithSub
            icon="/media/icons/duotune/coding/cod001.svg"
            fontIcon="bi-layers"
            to="/administracion/"
            title="Configuración"
            hasBullet={false}
          >
            <AsideMenuItem
              to="/administracion/usuarios"
              title="Usuarios"
              icon="/media/icons/duotune/general/gen049.svg"
            />
            <AsideMenuItem
              to="/administracion/retiros"
              title="Límites de Retiros"
              icon="/media/icons/duotune/finance/fin010.svg"
            />
          </AsideMenuItemWithSub>
        </>
      )}
    </>
  );
}
